import { jsonAuthHeaders } from "./authHeaders";

const API_BASE = "https://dobiecore-remix.melanie-brown.workers.dev/api";

const PRO_CACHE_KEY = "dcc_pro_cache";
const PRO_CACHE_TIME_KEY = "dcc_pro_cache_time";
const PRO_CACHE_EMAIL_KEY = "dcc_pro_cache_email";

export async function isPro(email) {
  if (!email) return false;

  const cached = localStorage.getItem(PRO_CACHE_KEY);          // "true" or null
  const cachedEmail = localStorage.getItem(PRO_CACHE_EMAIL_KEY); // stored email
  const cachedTime = parseInt(localStorage.getItem(PRO_CACHE_TIME_KEY) || "0", 10);
  const now = Date.now();

  const sameEmail = cachedEmail === email;

  // only reuse cache if it's for THIS email and recent
  if (sameEmail && cached === "true" && now - cachedTime < 5 * 60 * 1000) {
    return true;
  }
  if (sameEmail && cached === "false" && now - cachedTime < 5 * 60 * 1000) {
    return false;
  }

  try {
    const res = await fetch(`${API_BASE}/check-pro`, {
      method: "POST",
      headers: await jsonAuthHeaders(),
      body: JSON.stringify({ email }),
    });

    if (res.ok) {
      const data = await res.json(); // { isPro: boolean }
      const isProUser = !!data.isPro;

      localStorage.setItem(PRO_CACHE_KEY, isProUser ? "true" : "false");
      localStorage.setItem(PRO_CACHE_EMAIL_KEY, email);
      localStorage.setItem(PRO_CACHE_TIME_KEY, String(now));

      return isProUser;
    }

    // non-OK response -> treat as not pro for now
    localStorage.setItem(PRO_CACHE_KEY, "false");
    localStorage.setItem(PRO_CACHE_EMAIL_KEY, email);
    localStorage.setItem(PRO_CACHE_TIME_KEY, String(now));
    return false;
  } catch (err) {
    console.warn("Pro check failed; treating as free user", err);
    // optional: you could *not* cache this so it retries next time
    localStorage.setItem(PRO_CACHE_KEY, "false");
    localStorage.setItem(PRO_CACHE_EMAIL_KEY, email);
    localStorage.setItem(PRO_CACHE_TIME_KEY, String(now));
    return false;
  }
}

// The free caption allowance is counted by the server (begin_caption_generation, per
// account and UTC day), so the browser keeps no count of its own: a local count, keyed
// on the browser's calendar day, could block a request the server would allow. This
// states the rule; the worker's 429 free_limit_reached says when it is reached.
export function getUsageLabel(isProUser) {
  if (isProUser) return "Pro: unlimited captions";
  return "Free: 2 caption requests a day, reset at midnight UTC";
}
